import { render, staticRenderFns } from "./SmileStart.vue?vue&type=template&id=6b44ec7a&scoped=true"
import script from "./SmileStart.vue?vue&type=script&lang=js"
export * from "./SmileStart.vue?vue&type=script&lang=js"
import style0 from "./SmileStart.vue?vue&type=style&index=0&id=6b44ec7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44ec7a",
  null
  
)

export default component.exports